import { inject, Injectable, signal } from '@angular/core';
import { ReadonlyRepositoryListService } from '@softline/core';
import { WorkflowTypesRepository } from '../repositories/workflow-types.repository';
import { WorkflowType } from '../types/workflow-type';

@Injectable()
export class WorkflowTypesService extends ReadonlyRepositoryListService<
  WorkflowType,
  WorkflowType[],
  undefined
> {
  constructor() {
    super(inject(WorkflowTypesRepository));
  }

  params = signal(undefined);

  protected override getItems(result: WorkflowType[] | null | undefined): WorkflowType[] {
    return (result ?? []).sort((a, b) =>
      a.definitionName.localeCompare(b.definitionName)
    );
  }
}
